var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"playerContainer",staticClass:"playerContainer"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-centered",attrs:{"poster":_vm.thumbnail}})])}
var staticRenderFns = []

export { render, staticRenderFns }